<template>
  <v-card>
    <v-toolbar dense>
      <v-container fluid class="d-flex px-0 px-sm-3 py-0">
        <v-toolbar-title>Inspection Logs</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
            icon
            small
            @click="$emit('close')"
            class="px-0 min-width"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-container>
    </v-toolbar>
    <v-container fluid>
      <v-card>
        <v-data-table
            :loading="loading"
            disable-sort
            :items="logs"
            item-key="id"
            :headers="logHeaders"
            :mobile-breakpoint="0"
            :items-per-page="5"
        >
          <template v-slot:item.datetime="{item}">
            <div v-html="dateTimeFormat(item.datetime)" class="fill-height"></div>
          </template>
          <template v-slot:item.log="{item}">
            <div v-html="item.log.replace(/(?:\r\n|\r|\n)/g, '<br>') "></div>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-card>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'InspectionLogs',
  props: {
    inspectionId: {
      type: Number,
      required: true,
    },
    dateTimeFormat: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      logs: [],
      logHeaders: [
        {text: 'Date/Time', value: 'datetime'},
        {text: 'Log', value: 'log', width: '80%'},
      ],
    }
  },
  watch: {
    inspectionId: {
      immediate: true,
      handler() {
        this.logs = []
        this.loading = true
        this.retrieveLogs(this.inspectionId)
            .then(response => this.logs = response.data.data)
            .then(() => this.loading = false)
      },
    },
  },
  methods: {
    ...mapActions(['retrieveLogs']),
  },
}
</script>

<style scoped>
.min-width {
  min-width: 16px !important;
}
</style>